import {i18n} from "@/lang";
import {getTextLength} from "@/utils/util";

let flexWidth = (prop, tableData, title, num = 0) => {
    if (tableData.length === 0) {
        //表格没数据不做处理
        return;
    }
    let flexWidth = 0; //初始化表格列宽
    let columnContent = ""; //占位最宽的内容
    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");
    context.font = "14px Microsoft YaHei";
    if (prop === "" && title) {
        //标题长内容少的，取标题的值,
        columnContent = title;
    } else {
        // 获取该列中占位最宽的内容
        let index = 0;
        for (let i = 0; i < tableData.length; i++) {
            const now_temp = tableData[i][prop] + "";
            const max_temp = tableData[index][prop] + "";
            const now_temp_w = context.measureText(now_temp).width;
            const max_temp_w = context.measureText(max_temp).width;
            if (now_temp_w > max_temp_w) {
                index = i;
            }
        }
        columnContent = tableData[index][prop];
        //比较占位最宽的值跟标题、标题为空的留出四个位置
        const column_w = context.measureText(columnContent).width;
        const title_w = context.measureText(title).width;
        console.log(column_w, title_w, 'dddd')
        if (column_w < title_w) {
            columnContent = title || "未知标题";
        }
    }
    // 计算最宽内容的列宽
    let width = context.measureText(columnContent);
    flexWidth = width.width + 20 + num;
    if (flexWidth > 320) {
        flexWidth = 320;
    }
    if (title === i18n.global.t('common.customer.source') || title === i18n.global.t('common.interest.product')) {
        console.log(columnContent, getTextLength(columnContent), prop, tableData, title, num = 0, '内容')
        flexWidth = flexWidth + getTextLength(columnContent) + 15
    }
    // 如果列是一个数组？
    if (Array.isArray(columnContent)) {
        flexWidth = context.measureText(columnContent[0]).width
    }
    return flexWidth;
};

// 依据“实际展示内容”(截断后的首标签 + 可能的 +N 按钮)计算标签列宽，
// 避免用原始拼接字段(flexWidth)高估，也避免死封顶裁切合法长标签。
// displayItems: [{ text: 首标签展示文本, hasExtra: 是否有 +N 按钮 }]
// title: 表头文案（保证表头可完整显示）
let flexTagWidth = (displayItems = [], title = "", {min = 120, max = 200} = {}) => {
    let canvas = document.createElement("canvas");
    let context = canvas.getContext("2d");
    context.font = "14px Microsoft YaHei";

    const TAG_CHROME = 24;   // el-tag 内边距 + 边框
    const BUTTON_WIDTH = 42; // “+N” 按钮宽度 + 左外边距
    const CELL_PADDING = 24; // 单元格左右内边距

    // 表头需要完整显示（含排序/内边距留白）
    let maxContent = context.measureText(title || "").width + 20;

    if (Array.isArray(displayItems)) {
        for (const item of displayItems) {
            if (!item || !item.text) continue;
            let contentWidth = context.measureText(item.text).width + TAG_CHROME;
            if (item.hasExtra) contentWidth += BUTTON_WIDTH;
            if (contentWidth > maxContent) maxContent = contentWidth;
        }
    }

    const result = Math.ceil(maxContent + CELL_PADDING);
    return Math.min(Math.max(result, min), max);
};

export {flexWidth, flexTagWidth};

